import React from 'react';
import { RichText } from '../../richText';
import styled from 'styled-components';
import { Block } from '../../other/block';

const ColumnsContainer = styled.div<{itemCount: number}>(({itemCount}) => {
  const count = itemCount <= 3 ? itemCount : Math.ceil(itemCount / 2);
  return `
  display: grid;
  grid-gap: 2.5rem;
  grid-template-columns: 1fr;

  @media (min-width: 768px) {
    grid-template-columns: repeat(${Math.ceil(count)}, 1fr);
  }
  `;
});

const CtaLink = styled.a`
    text-decoration: underline;
    text-decoration-thickness: 3px;
    text-decoration-color: #46FF46;
    font-weight:400;
`;

interface ColumnsProps {
  heading: string;
  introduction: string;
  columns: any;
  backgroundColour?: string;
}

export const Columns = ({ heading, introduction, columns, backgroundColour }: ColumnsProps) => {
  return (
    <Block backgroundColour={backgroundColour}>
      <div className="w-full mx-auto md:max-w-5xl">
        {heading &&
          <h2 className="text-1.5xl md:text-center uppercase mb-10 md:mb-20 leading-none">{heading}</h2>
        }
        {introduction &&
          <p className={'font-playfair text-4xl leading-12 mb-12'}>{introduction}</p>
        }
        <ColumnsContainer itemCount={columns.length}>
          {columns.map((column: any, index: number) => (
            <div key={index} className="">
              <RichText key={index} content={column.content} />
              {column.callToActionText && (
                  <div className="mt-8 font-medium text-center uppercase">
                    <CtaLink href={column.callToActionUrl ? column.callToActionUrl : '#'}>
                      {column.callToActionText}
                    </CtaLink>
                  </div>
                )
              }
            </div>
          ))}
        </ColumnsContainer>
      </div>
    </Block>
  );
};
